import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  FaHome, 
  FaTag, 
  FaRoute, 
  FaWallet 
} from 'react-icons/fa';

const MobileFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const footerItems = [
    {
      id: 'home',
      label: 'Home',
      icon: FaHome,
      path: '/',
      isActive: location.pathname === '/'
    },
    {
      id: 'offers',
      label: 'Offers',
      icon: FaTag,
      path: '/offers',
      isActive: location.pathname.includes('/offers') && location.pathname !== '/'
    },
    {
      id: 'my-trip',
      label: 'My Trip',
      icon: FaRoute,
      path: '/my-trips',
      isActive: location.pathname.includes('/my-trips') || location.pathname.includes('/bookings')
    },
    {
      id: 'wallet',
      label: 'Travel Wallet',
      icon: FaWallet,
      path: '/wallet',
      isActive: location.pathname.includes('/wallet')
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="flex items-center justify-around py-2 px-1">
        {footerItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item.path)}
              className={`flex flex-col items-center justify-center py-2 px-2 min-w-0 flex-1 transition-all duration-200 rounded-lg ${
                item.isActive
                  ? 'text-primary-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon 
                className={`text-lg mb-1 ${
                  item.isActive ? 'text-primary-600' : 'text-gray-500'
                }`} 
              />
              <span className={`text-xs font-medium leading-tight ${
                item.isActive ? 'text-primary-600' : 'text-gray-500'
              }`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileFooter;
